module.exports = __webpack_public_path__ + "static/media/Kamel.1d13401a.PNG";